import React, {Component} from "react";
import { withRouter } from "react-router";
import $ from "jquery";
import {CommandContext} from "@mnjsplatform/data";
class PageWrapper extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = async()=> {
        this.initialize();
    }

    initialize = async () => {
        this.scrollToAnchor();
    }
    getHash = (hash) => {
        try {
            return $(hash) ? hash : '';
        }
        catch (e) {
            console.error(e);
            return '';
        }
    };

    scrollToAnchor = () => {
        if (this.getHash(this.props.location.hash) !== '') {

            console.log("scrollToAnchor: " + this.props.location.hash);

            const offset = $(this.props.location.hash).offset();
            if (!offset)
                return;

            $('html, body').animate({scrollTop: offset.top}, 'slow');
        }
    }

    render() {
        return this.props.children;
    }
}

PageWrapper.propTypes = {
}

PageWrapper.defaultProps = {};
export default withRouter(PageWrapper);